import { Clock, Bike, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { BUSINESS } from "../data/business";
import { ChapterHeader, Reveal } from "./Reveal";

export const LocationSection = () => (
  <section id="lokacija" className="relative py-28 sm:py-40 bg-white border-t border-black/5" data-testid="location-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <ChapterHeader
        number="06"
        title={<>Nađi nas <span className="text-leafdark">ili ti stižemo</span></>}
        sub="Kneza Miloša bb, Kragujevac. Dostavu vrše Glovo i Wolt — poruči u par klikova."
      />

      <div className="grid lg:grid-cols-2 gap-6 items-stretch">
        <div className="grid sm:grid-cols-2 gap-5">
          <Reveal className="sm:col-span-2">
            <div data-testid="location-hours-card" className="glow-card h-full rounded-[1.5rem] border border-leaf/20 bg-white p-7">
              <Clock className="w-6 h-6 text-ember mb-5" />
              <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-leafdark/70 mb-4">Radno vreme</p>
              <div className="space-y-3">
                {BUSINESS.hours.map((h) => (
                  <div key={h.days} className="flex items-baseline justify-between gap-4">
                    <span className="text-sm text-leafdark">{h.days}</span>
                    <span className="price-leader" />
                    <span className="font-mono-x font-bold text-sm text-ember whitespace-nowrap">{h.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.08}>
            <div data-testid="location-phone-card" className="glow-card h-full rounded-[1.5rem] border border-leaf/20 bg-white p-7 flex flex-col">
              <Phone className="w-6 h-6 text-ember mb-5" />
              <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-leafdark/70">Pozovi nas</p>
              <div className="mt-3 space-y-2">
                {BUSINESS.phones.map((p) => (
                  <a
                    key={p.tel}
                    data-testid={`location-phone-${p.tel}`}
                    href={`tel:${p.tel}`}
                    className="block font-display font-extrabold text-xl text-leafdark hover:text-ember transition-colors"
                  >
                    {p.label}
                  </a>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.14}>
            <div data-testid="delivery-info-banner" className="glow-card h-full rounded-[1.5rem] border border-leaf/35 bg-white p-7 flex flex-col">
              <Bike className="w-6 h-6 text-leaf mb-5" />
              <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-leafdark/70">Dostava</p>
              <p className="font-display font-extrabold text-xl text-leafdark mt-3">Glovo & Wolt</p>
              <p className="text-leafdark/85 text-sm leading-relaxed mt-2">
                Dostava stiže isključivo preko Glovo i Wolt aplikacija.
              </p>
              <div className="flex flex-wrap gap-2.5 mt-4">
                <a data-testid="location-glovo-btn" href={BUSINESS.glovo} target="_blank" rel="noopener noreferrer" className="bg-ember text-white text-[11px] font-bold uppercase tracking-wide rounded-full px-4 py-2.5 hover:bg-emberglow transition-colors">
                  Naruči preko Glovo-a
                </a>
                <a data-testid="location-wolt-btn" href={BUSINESS.wolt} target="_blank" rel="noopener noreferrer" className="border-2 border-leaf text-leafdark text-[11px] font-bold uppercase tracking-wide rounded-full px-4 py-2 hover:bg-leaf hover:text-white transition-colors">
                  Naruči preko Wolt-a
                </a>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="h-full">
          <div className="relative h-full min-h-[380px] rounded-[1.75rem] overflow-hidden border-2 border-leaf/25 shadow-[0_30px_60px_-25px_rgba(27,21,18,0.3)]">
            <iframe
              data-testid="location-map-embed"
              title="Do jaja — Kneza Miloša bb, Kragujevac"
              src={BUSINESS.mapsEmbed}
              className="absolute inset-0 w-full h-full"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
            <a
              data-testid="location-maps-btn"
              href={BUSINESS.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-4 left-4 flex items-center gap-2 bg-white/95 backdrop-blur rounded-full px-5 py-3 text-sm font-semibold text-leafdark shadow-lg hover:text-ember transition-colors"
            >
              <MapPin className="w-4 h-4 text-ember" />
              {BUSINESS.address}
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <a
          data-testid="location-call-btn"
          href={`tel:${BUSINESS.phones[0].tel}`}
          className="mt-8 group flex items-center justify-between bg-chili text-white rounded-[1.5rem] px-8 py-6 hover:bg-chilidark transition-colors duration-300"
        >
          <span className="font-display font-bold uppercase text-lg sm:text-xl">
            Pozovi {BUSINESS.phones[0].label}
          </span>
          <ArrowUpRight className="w-6 h-6 transition-transform duration-300 group-hover:rotate-45" />
        </a>
      </Reveal>
    </div>
  </section>
);
